export const RewardModalWrapper = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
	};

	return (
		<div 
			className="reward-modal"
			data-open="true"
			onClick={handleClick}
		>
			<div className="reward-modal__backdrop"></div>
			
			{children}
		</div>
	);
};
